import React from 'react';
import styled from '@emotion/styled';
import { RadioSelectableCard as AdsRadioSelectableCard, RadioSelectableCardProps } from '@qbe/ads-core';

// Fix to ADS RadioSelectableCard component to allow our reusable InformationPopUp titlePrefix component to be positioned from the FormCard left border.
// Without the fix the popup is positioned from the components left border.
// Wrapper component is required as was unable to directly override styles on RadioSelectableCard itself.

const PositionOverrideWrapper = styled.div`
  .selectable-card {
    position: unset;
  }
`;

export const RadioSelectableCard = (props: RadioSelectableCardProps) => (
  <PositionOverrideWrapper>
    <AdsRadioSelectableCard {...props} />
  </PositionOverrideWrapper>
);

export default RadioSelectableCard;
